import Send from '@/config/api/index'

const authPath = '/v1/auth'

export default {

    test() {
        return Send.post(authPath + '/test')
    },
    logout() {
        return Send.post(authPath + '/logout')
    },
    init() {
        return Send.post(authPath + '/init')
    },
    refresh() {
        return Send.post(authPath + '/refresh');
    },
    devToken(params) {
        return Send.post(authPath + '/dev-token', params)
    },
}
